import React from "react";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getApi } from '../../services/apiServices';
import { toast } from 'react-toastify';

function ViewMatchManagement() {
    const { id } = useParams();
    const [matchData, setMatchData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('timeline');

    const fetchMatchDetails = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await getApi(`matches/${id}`);

            if (response?.statusCode === 200) {
                setMatchData(response.data);
            } else {
                setError(response?.message || 'Failed to fetch match details');
                toast.error(response?.message || 'Failed to fetch match details');
            }
        } catch (error) {
            setError('Error fetching match details. Please try again.');
            toast.error('Error fetching match details. Please try again.');
            console.error('Error fetching match details:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchMatchDetails();
        }
    }, [id]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatDuration = (seconds) => {
        if (!seconds) return 'N/A';
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}m ${remainingSeconds}s`;
    };

    const getStatusBadge = (status) => {
        if (status === 0) {
            return <span className="badge badge-warning">Pending</span>;
        } else if (status === 1) {
            return <span className="badge badge-success">Accepted</span>;
        } else if (status === 2) {
            return <span className="badge badge-danger">Rejected</span>;
        }
        return <span className="badge badge-secondary">Unknown</span>;
    };

    const getContactInfo = (user) => {
        if (user.email) {
            return user.email;
        } else if (user.phone_number) {
            return user.country_code 
                ? `${user.country_code} ${user.phone_number}`
                : user.phone_number;
        }
        return 'N/A';
    };

    const getContactLabel = (user) => {
        if (user.email) {
            return 'Email';
        } else if (user.phone_number) {
            return 'Phone';
        }
        return 'Contact';
    };

    if (loading) {
        return (
            <div className="right-section">
                <div className="loader-overlay">
                    <span className="loader"></span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="right-section">
                <div className="error-message">
                    <p>{error}</p>
                    <button onClick={fetchMatchDetails} className="btn btn-primary">Retry</button>
                </div>
            </div>
        );
    }

    if (!matchData) {
        return (
            <div className="right-section">
                <div className="error-message">
                    <p>No match data found</p>
                </div>
            </div>
        );
    }

    const { match, history, calls, feedback } = matchData;

    return (
        <>
            <div className="right-section">
                <div className="view-heading">
                    <ul>

                        <li>
                            <Link to="/admin/matchManagement" className="active">
                                <img
                                    src={window.getPublicUrl("/images/back-button.svg")}
                                    alt="Back"
                                />{" "}
                                Back to User
                            </Link>
                        </li>
                    </ul>
                </div>

                {/* Profile Details */}
                <div className="profile-data match-mangement">
                    <div className="w-100">
                        <div className="w-50">
                            <div className="row">
                                <div className="col-md-5">
                                    <ul className="user-data">
                                        <li>
                                            <span>
                                                <img 
                                                    src={
                                                        match.user.User_Images && match.user.User_Images.length > 0
                                                            ? match.user.User_Images[0].image
                                                            : window.getPublicUrl('/images/john.svg')
                                                    } 
                                                    alt="User" 
                                                />
                                            </span>
                                        </li>
                                        <li>
                                            <h3 className="profile-haeding">{match.user.full_name}</h3>
                                            <p className="view-profle">
                                                <Link to={`/admin/viewUserManagement/${match.user.id}`}>View profile</Link>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-7">
                                    <div className="inner-profile-data">
                                        <ul className="user-list-data pt-0">
                                            <li>
                                                <p>{getContactLabel(match.user)}</p>
                                                <span>
                                                    <img src={window.getPublicUrl('/images/line.svg')} alt="" />
                                                </span>
                                                <h4>{getContactInfo(match.user)}</h4>
                                            </li>
                                            <li>
                                                <p>Plan</p>
                                                <span>
                                                    <img src={window.getPublicUrl('/images/line.svg')} alt="" />
                                                </span>
                                                <h4>{match.user.package_type === 1 ? 'Premium' : 'Free'}</h4>
                                            </li>
                                            <li>
                                                <p>Verified</p>
                                                <span>
                                                    <img src={window.getPublicUrl('/images/line.svg')} alt="" />
                                                </span>
                                                <h4>{match.user.email_verify ? 'Yes' : 'No'}</h4>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-50">
                            <div className="row">
                                <div className="col-md-5">
                                    <ul className="user-data">
                                        <li>
                                            <span>
                                                <img 
                                                    src={
                                                        match.otherUser.User_Images && match.otherUser.User_Images.length > 0
                                                            ? match.otherUser.User_Images[0].image
                                                            : window.getPublicUrl('/images/profile-two.svg')
                                                    } 
                                                    alt="User" 
                                                />
                                            </span>
                                        </li>
                                        <li>
                                            <h3 className="profile-haeding">{match.otherUser.full_name}</h3>
                                            <p className="view-profle">
                                                <Link to={`/admin/viewUserManagement/${match.otherUser.id}`}>View profile</Link>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-7">
                                    <div className="inner-profile-data">
                                        <ul className="user-list-data pt-0">
                                            <li>
                                                <p>{getContactLabel(match.otherUser)}</p>
                                                <span>
                                                    <img src={window.getPublicUrl('/images/line.svg')} alt="" />
                                                </span>
                                                <h4>{getContactInfo(match.otherUser)}</h4>
                                            </li>
                                            <li>
                                                <p>Plan</p>
                                                <span>
                                                    <img src={window.getPublicUrl('/images/line.svg')} alt="" />
                                                </span>
                                                <h4>{match.otherUser.package_type === 1 ? 'Premium' : 'Free'}</h4>
                                            </li>
                                            <li>
                                                <p>Verified</p>
                                                <span>
                                                    <img src={window.getPublicUrl('/images/line.svg')} alt="" />
                                                </span>
                                                <h4>{match.otherUser.email_verify ? 'Yes' : 'No'}</h4>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="tabs-ui">
                    <div className="customer-top-left">
                        <ul>
                            <li>
                                <a
                                    href="#"
                                    className={activeTab === 'timeline' ? 'active' : ''}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setActiveTab('timeline');
                                    }}
                                >
                                    Timeline
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    className={activeTab === 'calls' ? 'active' : ''}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setActiveTab('calls');
                                    }}
                                >
                                    Video Call
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    className={activeTab === 'feedback' ? 'active' : ''}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setActiveTab('feedback');
                                    }}
                                >
                                    Feedback
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Timeline Tab */}
                {activeTab === 'timeline' && (
                    <div className="customer-tablle-main match-management-view-table">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col" className="date">Date</th>
                                    <th scope="col" className="chat">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {history && history.length > 0 ? (
                                    history.map((item, index) => (
                                        <tr key={index}>
                                            <td className="date">{formatDate(item.createdAt)}</td>
                                            <td className="chat">{item.description}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-center">No timeline data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Calls Tab */}
                {activeTab === 'calls' && (
                    <div className="customer-tablle-main video-call-data">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col" className="date">Date</th>
                                    <th scope="col" className="time">Time</th>
                                    <th scope="col" className="scheduled-by">Scheduled By</th>
                                    <th scope="col" className="duration">Duration</th>
                                    <th scope="col" className="plan">Plan</th>
                                    <th scope="col" className="status">Status</th>
                                    <th scope="col" className="feedback">Feedback</th>
                                </tr>
                            </thead>
                            <tbody>
                                {calls && calls.length > 0 ? (
                                    calls.map((call) => {
                                        const callDate = new Date(call.date_time);
                                        const totalDuration = call.Call_Durations ? call.Call_Durations.reduce((sum, d) => sum + d.call_duration_time, 0) : 0;
                                        const hasFeedback = feedback && feedback.some(f => f.schedule_id === call.id);

                                        return (
                                            <tr key={call.id}>
                                                <td className="date">{callDate.toLocaleDateString('en-US', {
                                                    day: 'numeric',
                                                    month: 'short',
                                                    year: 'numeric'
                                                })}</td>
                                                <td className="time">{callDate.toLocaleTimeString('en-US', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: true
                                                })}</td>
                                                <td className="scheduled-by">{call.callScheduler.full_name}</td>
                                                <td className="duration">
                                                    {totalDuration > 0 ? formatDuration(totalDuration) : 'Not Started'}
                                                </td>
                                                <td className="plan">
                                                    <span className={`plan-badge ${call.callScheduler.package_type === 1 ? 'premium' : 'free'}`}>
                                                        {call.callScheduler.package_type === 1 ? 'Premium' : 'Free'}
                                                    </span>
                                                </td>
                                                <td className="status">
                                                    <span className={`status-badge ${call.duration_left > 0 ? 'scheduled' : 'completed'}`}>
                                                        {call.duration_left > 0 ? 'Scheduled' : 'Completed'}
                                                    </span>
                                                </td>
                                                <td className="feedback">
                                                    {hasFeedback ? (
                                                        <div className="feedback-summary">
                                                            <span className="feedback-badge">✓ Available</span>
                                                            <div className="feedback-details">
                                                                {feedback.filter(f => f.schedule_id === call.id).map((f, idx) => (
                                                                    <div key={idx} className="feedback-item">
                                                                        <small>{f.User.full_name}: {f.rating}/5</small>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <span className="no-feedback">No Feedback</span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">No call data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Feedback Tab */}
                {activeTab === 'feedback' && (
                    <div className="customer-tablle-main">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col" className="user">User</th>
                                    <th scope="col" className="rating">Rating</th>
                                    <th scope="col" className="feedback-text">Feedback Text</th>
                                    <th scope="col" className="submitted-on">Submitted On</th>
                                </tr>
                            </thead>
                            <tbody>
                                {feedback && feedback.length > 0 ? (
                                    feedback.map((item, index) => (
                                        <tr key={index}>
                                            <td className="user">
                                                <div className="user-info">
                                                    <span className="user-name">{item.User.full_name}</span>
                                                </div>
                                            </td>
                                            <td className="rating">
                                                <div className="rating-display">
                                                    <div className="rating-stars">
                                                        {Array.from({ length: 5 }, (_, i) => (
                                                            <span key={i} className="star-filled">
                                                                {i < item.rating ? (
                                                                    <img
                                                                        src={window.getPublicUrl('/images/stars.svg')}
                                                                        alt="filled star"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={window.getPublicUrl('/images/without-fill-star.svg')}
                                                                        alt="empty star"
                                                                    />
                                                                )}
                                                            </span>
                                                        ))}
                                                    </div>
                                                    <span className="rating-number">{item.rating}/5</span>
                                                </div>

                                            </td>
                                            <td className="feedback-text">
                                                <div className="feedback-content">
                                                    {/* <div className="feedback-span">
                                                        <span>Good </span><span>Stood Out</span> <span>Great ConversationFelt Authentic</span>
                                                    </div> */}
                                                    <div className="comment-text">{item.comment}</div>
                                                    {/* {item.stood_out && item.stood_out.length > 0 && (
                                                        <div className="stood-out-section">
                                                            <span className="stood-out-label">Stood Out:</span>
                                                            <div className="tags">
                                                                {item.stood_out.map((trait, idx) => (
                                                                    <span key={idx} className="tag">{trait}</span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )} */}
                                                    {item.stood_out && item.stood_out.length > 0 && (
                                                        <div className="feedback-span">
                                                            {item.stood_out.map((trait, idx) => (
                                                                <span key={idx}>{trait}</span>
                                                            ))}
                                                        </div>
                                                    )}

                                                </div>
                                            </td>
                                            <td className="submitted-on">
                                                <div className="submission-date">
                                                    {formatDate(item.createdAt)}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">No feedback data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}


                {/* 
  <div className="chat-section">
    <div className="chat-description">
      <p className="blank-pera">This chat is private and has not been reported.</p>
      <p>Admin cannot view conversations unless a report has been filed.</p>
    </div>
  </div>
  */}
            </div>


        </>
    );
}

export default ViewMatchManagement;
